// Company Information
export const COMPANY_INFO = {
  name: 'MTAI',
  fullName: 'M Telecommunications Sdn Bhd',
  tagline: 'AI Technology',
  description: 'We are proud to be Malaysia\'s pioneering full-stack AI service provider, offering comprehensive solutions that cover everything from computing infrastructure to software development and seamless deployment.',
  
  // Contact Information
  contact: {
    phone: '+603-2242 0666',
    fax: '+603-2242 0667',
    email: 'admin@mtai.com.my',
    website: 'https://www.mtai.com.my',
  },
  
  // Address
  address: {
    street: 'Level 30, South Wing, Menara TM,',
    city: 'Kuala Lumpur',
    state: 'Wilayah Persekutuan,',
    postcode: 'Jalan Pantai Baharu, 50672',
    country: 'Malaysia',
  },
  
  // Business Hours
  businessHours: {
    weekdays: '9:00 AM - 6:00 PM',
    saturday: '9:00 AM - 1:00 PM',
    sunday: 'Closed',
  },
  
  // Social Media
  social: {
    facebook: 'https://www.facebook.com/profile.php?id=61577973490752',
    x: 'https://x.com/mtai_life',
    instagram: 'https://www.instagram.com/mtai.life',
    tiktok: 'https://www.tiktok.com/@mtai.life',
    linkedin: 'https://www.linkedin.com/company/m-telecommunications/',
  },
};

// Navigation Menu Items (Simplified navigation)
export const NAVIGATION_ITEMS = [
  { label: 'Home', href: '/', hasDropdown: false },
  { label: 'About Us', href: '/about', hasDropdown: false },
  { 
    label: 'Services', 
    href: '/services', 
    hasDropdown: true,
    dropdownItems: [
      { label: 'Built-to-Suit GPU Compute Clusters', href: '/services/gpu-clusters' },
      { label: 'NVIDIA GPU Node Leasing', href: '/services/gpu-leasing' },
      { label: 'On-Demand Compute Service', href: '/services/on-demand' },
      { label: 'AI Software Solutions', href: '/services/ai-solutions' },
    ]
  },
  { label: 'Careers', href: '/careers', hasDropdown: false }
];

// Company Links for Footer (separate from main navigation)
export const COMPANY_LINKS = [
  { label: 'About Us', href: '/about' },
  { label: 'Contact Us', href: '/contact' },
  { label: 'Privacy Policy', href: '/privacy' },
];

// Partner Companies (from actual WordPress site)
export const PARTNERS = [
  {
    name: 'NVIDIA',
    logo: '/assets/images/partners/Nvidia_Logo.png',
    description: 'AI | GPU',
    website: 'https://www.nvidia.com',
  },
  {
    name: 'Supermicro',
    logo: '/assets/images/partners/Supermicro_Logo.png',
    description: 'Server | Storage',
    website: 'https://www.supermicro.com',
  },
  {
    name: 'ASUS',
    logo: '/assets/images/partners/Asus_Logo.png',
    description: 'Computer | Electronics',
    website: 'https://www.asus.com',
  },
  {
    name: 'AMD',
    logo: '/assets/images/partners/AMD_Logo.png',
    description: 'Computing',
    website: 'https://www.amd.com',
  },
  {
    name: 'Intel',
    logo: '/assets/images/partners/Intel_Logo.png',
    description: 'Semiconductor | Computing',
    website: 'https://www.intel.com',
  },
  {
    name: 'Mellanox',
    logo: '/assets/images/partners/Mellanox_Logo.png',
    description: 'High-Performance',
    website: 'https://www.mellanox.com',
  },
];

// Services Information (from actual WordPress content)
export const SERVICES = [
  {
    id: 'full-stack',
    title: 'Full-Stack Solutions',
    description: 'From compute to code, we handle everything under one roof.',
    icon: '/assets/images/services/Full_Stack_Icon_1.png',
    href: '/service/ai-software-solutions',
  },
  {
    id: 'scalable-cloud',
    title: 'Scalable Cloud',
    description: 'Flexibility and scalability that grows with your business.',
    icon: '/assets/images/services/Cloud_Icon6_1.png',
    href: '/service/on-demand-compute-service',
  },
  {
    id: 'seamless-deployment',
    title: 'Seamless Deployment',
    description: 'Get your applications to market faster with fully managed deployment services.',
    icon: '/assets/images/services/seemless-depolyment_1.png',
    href: '/service/built-to-suit-gpu-compute-clusters',
  },
  {
    id: 'local-expertise',
    title: 'Dedicated Local Expertise',
    description: 'Proudly serving Malaysia and Southeast Asia with a team that understands local market dynamics.',
    icon: '/assets/images/services/local-expertise_1.png',
    href: '/about-us',
  },
];

// About Us Content (from actual WordPress site)
export const ABOUT_CONTENT = {
  title: 'About',
  description: `At MTAI, we are proud to be Malaysia's pioneering full-stack AI service provider, offering comprehensive solutions that cover everything from computing infrastructure to software development and seamless deployment. Our mission is to empower businesses with cutting-edge technology, blending the power of cloud computing and artificial intelligence to accelerate growth, streamline operations, and unlock new opportunities.

Whether you need scalable cloud infrastructure, AI-driven software, or fully managed deployment solutions, we deliver end-to-end services that are tailored to your specific needs. From startups to enterprises, we ensure that your business stays ahead in the digital era with a complete stack of future-ready technology solutions.`,
  image: '/assets/images/about/Who_Are_We.jpg',
};

// Product Showcase (from actual WordPress site)
export const PRODUCT_SHOWCASE = [
  {
    name: 'GPU Hardware',
    image: '/assets/images/products/GPU1.png',
    alt: 'GPU1',
  },
  {
    name: 'GPU Systems',
    image: '/assets/images/products/GPU2.png',
    alt: 'GPU2',
  },
  {
    name: 'Server Infrastructure',
    image: '/assets/images/products/Server2.png',
    alt: 'Server2',
  },
  {
    name: 'Enterprise Servers',
    image: '/assets/images/products/Server1.png',
    alt: 'Server1',
  },
  {
    name: 'Data Center Solutions',
    image: '/assets/images/products/Server3.png',
    alt: 'Server3',
  },
];

// Animation Variants
export const ANIMATION_VARIANTS = {
  fadeIn: {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { duration: 0.6 }
    }
  },
  slideUp: {
    hidden: { opacity: 0, y: 50 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6 }
    }
  },
  slideInLeft: {
    hidden: { opacity: 0, x: -50 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: { duration: 0.6 }
    }
  },
  slideInRight: {
    hidden: { opacity: 0, x: 50 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: { duration: 0.6 }
    }
  },
  staggerChildren: {
    visible: {
      transition: {
        staggerChildren: 0.1
      }
    }
  }
};

// Hero Slider Content (from actual WordPress site)
export const HERO_CONTENT = {
  title: 'Unlock the Power of ',
  subtitle: 'AI Cloud Infrastructure & Software Solutions',
  description: 'To anchor Malaysia’s digital and AI future with infrastructure the nation can trust, own, and grow with.',
  backgroundImage: '/assets/images/hero/slider-img1-1.png',
  starImage: '/assets/images/hero/star-img.png',
  ctaText: 'Explore Our Services',
  ctaLink: '/#Services',
};

// Solutions
export const SOLUTIONS = [
  {
    id: 'enterprise',
    title: 'Enterprise Solutions',
    description: 'Comprehensive solutions for large enterprises.',
    target: 'Large Enterprises',
    features: [
      'Scalable Infrastructure',
      'Enterprise Security',
      'Business Continuity',
      'Performance Optimization',
    ],
  },
  {
    id: 'sme',
    title: 'SME Solutions',
    description: 'Cost-effective solutions tailored for small and medium enterprises.',
    target: 'Small & Medium Enterprises',
    features: [
      'Budget-Friendly Options',
      'Easy Implementation',
      'Scalable Growth',
      'Essential Security',
    ],
  },
  {
    id: 'government',
    title: 'Government Solutions',
    description: 'Secure and compliant solutions for government agencies.',
    target: 'Government Agencies',
    features: [
      'Regulatory Compliance',
      'High Security Standards',
      'Data Protection',
      'Public Service Optimization',
    ],
  },
];

// Contact Form Fields
export const CONTACT_SUBJECTS = [
  'General Inquiry',
  'Service Request',
  'Partnership Opportunity',
  'Technical Support',
  'Quote Request',
  'Other',
];


